module.exports = __webpack_public_path__ + "img/twitter.88d96d7.svg";